import { ButtonLink } from '../components/Button';
import { PageHero } from '../components/PageHero';
import { SEO } from '../lib/seo';

export function NotFound() {
  return (
    <>
      <SEO title="Page Not Found" description="The requested MaytoMation page could not be found." />
      <PageHero
        eyebrow="404"
        title="This page is not in the runbook."
        body="The link may have moved, or the address may be incorrect. Head back to the main site to keep going."
      />
      <section className="px-5 py-16 text-center">
        <ButtonLink to="/" variant="dark">
          Return Home
        </ButtonLink>
      </section>
    </>
  );
}
